import React, { useEffect, useState, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import API from "../Services/Report";
import APISS from "../Services/Location";
import "bootstrap-icons/font/bootstrap-icons.css";
import moment from "moment";
import Select from "react-select";
import * as XLSX from "xlsx";
const InventoryReport = () => {
    const [selectedCenter, setSelectedCenter] = useState("");
    const [inventoryData, setInventoryData] = useState([]);
    const [location, setLocation] = useState([]);

    const [isSearched, setIsSearched] = useState(false);
    const [loading, setLoading] = useState(false);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];

    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];

    const tableRef = useRef(null);

    const [totalRecord, setTotalRecord] = useState(0);
    const [recordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState({});
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState({
        from_date: formattedToday,
        to_date: formattedToday,
    });

    const perPage = 10;

    const getInventoryReport = async (page = 1) => {
        try {
            setLoading(true);

            const payload = {
                location_id: parseInt(selectedCenter) || null,
                from_date: search.from_date || formattedPastDate,
                to_date: search.to_date || formattedToday,
                page: page,
                page_size: perPage,
            };

            const response = await API.getInventoryReport(payload);

            const data = response?.data?.data;

            setInventoryData(data?.records || []);
            setTotalCount(data?.totals || {});

            const totalRecords = data?.pagination?.["Total Records"] || 0;

            setTotalRecord(totalRecords);

            // IMPORTANT: calculate total pages
            setTotalPages(Math.ceil(totalRecords / perPage));

        } catch (error) {
            console.error(error);

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
                return;
            }

            toast.error("Failed to fetch inventory data");
        } finally {
            setLoading(false);
        }
    };


    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });

            setLocation(response?.data?.data || []);
        } catch (error) {
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        bindLocation();
    }, []);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (fieldName === "from_date") {
            const newToDate = moment(value).add(90, "days");

            const finalToDate = newToDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newToDate.format("YYYY-MM-DD");

            setSearch((prev) => ({
                ...prev,
                from_date: value,
                to_date: finalToDate,
            }));
        } else {
            setSearch((prev) => ({
                ...prev,
                [fieldName]: value,
            }));
        }
    };

    const handleSearch = () => {
        if (!selectedCenter) {
            toast.error("Please select a center before searching");
            return;
        }
        setCurrentPage(1);
        setIsSearched(true);
        getInventoryReport(1);
    };

    const locationOptions = location.map((item) => ({
        value: item.id,
        label: item.name,
    }));
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
            getInventoryReport(newPage);
        }
    };

const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
    } else {
        pages.push(1);

        if (currentPage > 4) {
            pages.push("...");
        }

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (currentPage < totalPages - 3) {
            pages.push("...");
        }

        pages.push(totalPages);
    }

    return pages;
};
    const downloadCSV = async () => {
        try {
               const payload = {
                location_id: parseInt(selectedCenter) || null,
                from_date: search.from_date || formattedPastDate,
                to_date: search.to_date || formattedToday,
                page: 1,
                page_size: totalRecord,
            };
            // console.log('download ',payload);

            const response = await API.getInventoryReport(payload);
          //  console.log('response?.data?.data',response?.data?.data);
            const result = response?.data?.data?.records || [];
            if (!result.length) {
                toast.error("No data found!");
                return;
            }
            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "InventoryRecord");
            XLSX.writeFile(workbook, "InventoryRecord.xlsx");
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };

    return (
        <div>
            <ToastContainer />

            {/* ================= FILTER ================= */}
            <div className="card mt-3">
                <div className="card-header">
                    <h5 className="mb-0">Filter</h5>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Select Center</label>
                            <Select
                                options={locationOptions}
                                placeholder="Select Center"
                                onChange={(opt) => setSelectedCenter(opt?.value)}
                            />
                        </div>

                        <div className="col-md-4">
                            <label>From Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={search.from_date}
                                max={formattedToday}
                                onChange={(e) => handleFieldChange(e, "from_date")}
                            />
                        </div>

                        <div className="col-md-4">
                            <label>To Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={search.to_date}
                                min={search.from_date}
                                max={formattedToday}
                                onChange={(e) => handleFieldChange(e, "to_date")}
                            />
                        </div>

                        <div className="col-md-3 mt-3">
                            <button onClick={handleSearch} className="btn btn-success">
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= MESSAGE ================= */}
            {!isSearched && (
                <div className="text-center mt-4 text-muted">
                    Please select filters and click Search
                </div>
            )}

            {isSearched && (
                <div className="card mt-3" ref={tableRef}>
                    {/* HEADER */}
                    <div className="card-header">
                        <div className="d-flex justify-content-between flex-wrap gap-2">
                            <h5>
                                Inventory Report - ({totalRecord})

                            </h5>
                            {totalRecord > 0 && (
                                <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                    <i className="fa fa-download"></i>
                                </button>
                            )}

                            <div className="d-flex flex-wrap gap-3">

                                <div className="border rounded px-3 py-2">
                                    <span className="fw-semibold">Opening:</span>{" "}
                                    <span className="fw-bold">
                                        ₹ {totalCount?.["Total Opening (In Rs)"] || 0}
                                    </span>
                                </div>

                                <div className="border rounded px-3 py-2">
                                    <span className="fw-semibold">Balance:</span>{" "}
                                    <span className="fw-bold">
                                        ₹ {totalCount?.["Total Balance (In Rs)"] || 0}
                                    </span>
                                </div>

                                <div className="border rounded px-3 py-2">
                                    <span className="fw-semibold">Purchase:</span>{" "}
                                    <span className="fw-bold">
                                        ₹ {totalCount?.["Total Purchase (In Rs)"] || 0}
                                    </span>
                                </div>

                                <div className="border rounded px-3 py-2">
                                    <span className="fw-semibold">Consumption:</span>{" "}
                                    <span className="fw-bold">
                                        ₹ {totalCount?.["Total Consumption (In Rs)"] || 0}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center p-3">Loading...</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Date</th>
                                        <th>Center</th>
                                        <th>Product</th>
                                        <th>Type</th>
                                        <th>UOM-Qty</th>
                                        <th>UOM</th>
                                        <th>Unit Price</th>
                                        <th>Opening</th>
                                        <th>Purchase</th>
                                        <th>Consumption</th>
                                        <th>Balance</th>
                                        <th>Opening (Rs)</th>
                                        <th>Purchase (Rs)</th>
                                        <th>Consumption (Rs)</th>
                                        <th>Balance (Rs)</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {inventoryData.length > 0 ? (
                                        inventoryData.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {(currentPage - 1) * recordsPerPage +
                                                        index +
                                                        1}
                                                </td>
                                                <td>{item?.Date}</td>
                                                <td>{item?.Center}</td>
                                                <td>{item?.Product}</td>
                                                <td>{item?.Type}</td>
                                                <td>{item?.["UOM-Qty"]}</td>
                                                <td>{item?.UOM}</td>
                                                <td>{item?.["Unit Price"]}</td>
                                                <td>{item?.Opening}</td>
                                                <td>{item?.Purchase}</td>
                                                <td>{item?.Consumption}</td>
                                                <td>{item?.Balance}</td>
                                                <td>{item?.["Opening (In Rs)"]}</td>
                                                <td>{item?.["Purchase (In Rs)"]}</td>
                                                <td>{item?.["Consumption (In Rs)"]}</td>
                                                <td>{item?.["Balance (In Rs)"]}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="16">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""
                                                } ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(page)}
                                                >
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InventoryReport;